import React from "react";
import Table from "../../../components/Table";
import { LijfrenteUitkeringInfo } from "../../../../../.generated/rapportage/rapportagetypes";
import { getLijfrentesColumns } from "../../Producten/lijfrentes-kolommen";

export interface SingleLijfrentesTableProps {
  data: LijfrenteUitkeringInfo;
}

export interface LijfrentesTableProps {
  data: LijfrenteUitkeringInfo[];
}

export const SingleLijfrentesTable: React.FC<SingleLijfrentesTableProps> = ({
  data,
}: SingleLijfrentesTableProps) => {
  return (
    <div className="mb-4">
      <Table
        columns={getLijfrentesColumns(data.soortLijfrente, true)}
        data={[data]}
        rotate={true}
        showHeader={true}
        filterNullAnd0Columns={true}
        id={`lijfrentes-table-${data.maatschappij
          ?.replace(/\s+/g, "-")
          .toLowerCase() || "lijfrentes"}`}
      />
    </div>
  );
};

export const LijfrentesTable: React.FC<LijfrentesTableProps> = ({
  data,
}: LijfrentesTableProps) => {
  return (
    <div className="lijfrentes-section">
      {data.map((lijfrente, index) => (
        <SingleLijfrentesTable key={index} data={lijfrente} />
      ))}
    </div>
  );
};
